import './common/polyfills';
import { initHiddenSecrets } from './common/common';
import { initHeader } from './layout/header';
import { initProducts } from './layout/product';
import { initModules } from './modules';
import { initStdSearch } from './layout/search';
import { initGTMTracking } from './common/gtm';
import { initACBlocks, extendCoreBlocks } from './blocks/front';
import objectFitImages from 'object-fit-images';
jQuery(function () {
    initHiddenSecrets();
    initHeader();
    initProducts();
    initModules();
    initStdSearch();
    extendCoreBlocks();
    initACBlocks();
    objectFitImages();
    initGTMTracking();
});
